import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "for-customizing-the-templates-default-site-settings"
    }}>{`For customizing the template's default site settings:`}</h2>
    <blockquote>
      <p parentName="blockquote">{`[your-frontend-project]`}{` = admin `}{`[`}<inlineCode parentName="p">{`rest/graphql`}</inlineCode>{`]`}{` or shop`}</p>
    </blockquote>
    <p><inlineCode parentName="p">{`/admin`}</inlineCode>{` : In this portion all the admin dashboard related coding and functions.`}</p>
    <p><inlineCode parentName="p">{`/shop`}</inlineCode>{` : All the shop related coding and functions.`}</p>
    <p><inlineCode parentName="p">{`/api`}</inlineCode>{` : API related code for both graphql and rest.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      